import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { header } from "../globalVariables";
import { api, cleanJSON, isJSON } from "../pureFunctions";
import { FilterGenerator } from "./FilterGenerator";
import { SpinnerGroup } from "../Utils/SpinnerGroup";

const initKachel = {
   heading: { column: "heading", type: "TEXT", label: "Initialer Name der Kachel" },
   kachelId: { column: "kachel_id", type: "TEXT", label: "Kachel-ID" },
   kuerzel: { column: "kuerzel", type: "TEXT", label: "Kürzel" },
   stufenId: { column: "stufen_id", type: "TEXT" },
   filter: { column: "filter", type: "JSONB" },
   tenant: { column: "tenant", type: "TEXT" },
   hinweis: { column: "hinweis", type: "TEXT" },
   standardEskalationsfrist: { column: "standard_eskalationsfrist", type: "INTEGER" },
   maxEskalationsfrist: { column: "max_eskalationsfrist", type: "INTEGER" },
   pflichtEskalation: { column: "pflicht_eskalation", type: "BOOL" },
   pflichtKachel: { column: "pflicht_kachel", type: "BOOL" },
   adminFreigabe: { column: "admin_freigabe", type: "BOOL" },
   pmFreigabe: { column: "pm_freigabe", type: "BOOL" },
   notRemovable: { column: "not_removable", type: "BOOL" },
   unSkippable: { column: "un_skippable", type: "BOOL" },
   deprecated: { column: "deprecated", type: "BOOL" },
   optional: { column: "optional", type: "BOOL" },
   oneClickFinish: { column: "one_click_finish", type: "JSONB" },
   permittedUsers: { column: "permitted_users", type: "JSONB" },
   groups: { column: "groups", type: "JSONB" },
};

export function EditKachel({ kachelIndex, data, allKacheln, setAllKacheln, fieldconfiguration }) {
   const [settings, setSettings] = useState({
      ...data,
      filter: data.filter ? JSON.stringify(data.filter, null, 2) : "",
      permittedUsers: data.permittedUsers ? JSON.stringify(data.permittedUsers) : "",
   });
   const [loading, setLoading] = useState("");
   const [showWarning, setShowWarning] = useState();

   function editSettings(name, value) {
      setSettings((prev) => ({ ...prev, [name]: value }));
   }
   const [projektIds, setProjektIds] = useState(
      Object.keys(allKacheln).reduce((oldObj, item) => ({ ...oldObj, [item]: allKacheln[item].heading }), {}),
   );

   async function updateKachel() {
      console.log(settings);
      let cleanData = structuredClone(settings);
      cleanData.fields = allKacheln[data.stufenId].kachel.find((item) => item.kachelId === data.kachelId).fields;

      cleanJSON(cleanData, "permittedUsers");
      cleanJSON(cleanData, "filter");
      //{"op":"===","field":"kachel_status_uebergabe","value":4}
      console.log(cleanData);

      const savedResponse = await api
         .post("/api/ip/kacheln", { kachelId: cleanData.kachelId, ...cleanData }, header)
         .then((data) => {
            console.log("saved Data");
            console.log(data);
            return data.data;
         })
         .catch((err) => {
            console.log(err);
         });

      await api.get("/api/updateCache").then((data) => {
         console.log(data);
      });
   }

   async function archiveKachel() {
      await api
         .patch("/api/ip/archive-kachel", { kachelId: data.stufenId }, header)
         .then((data) => {
            console.log("saved Data");
            console.log(data);
            return data.data;
         })
         .catch((err) => {
            console.log(err);
         });

      let newKacheln = structuredClone(allKacheln);

      newKacheln[data.stufenId].kachel = newKacheln[data.stufenId].kachel.filter(
         (item) => item.kachelId !== data.kachelId,
      );
      setAllKacheln(newKacheln);

      await api.get("/api/updateCache").then((data) => {
         console.log(data);
      });
   }
   return (
      <div className="kachel-edit-menu">
         <h2>{kachelIndex} Kacheleinstellungen</h2>
         <Form className="mt-4">
            <Row>
               <Form.Group as={Col} className="mb-3">
                  <Form.Label>Initialer Name der Kachel</Form.Label>
                  <Form.Control
                     placeholder="z.B. Datenblatt"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                     value={settings.heading}
                     name={"heading"}
                  />
               </Form.Group>

               <Form.Group as={Col} className="mb-3">
                  <Form.Label>Kachel-Kürzel (2 Buchstaben)</Form.Label>
                  <Form.Control
                     placeholder="z.B. EW"
                     maxLength={2}
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                     value={settings.kuerzel}
                     name={"kuerzel"}
                  />
               </Form.Group>
            </Row>
            <Row>
               <Col>
                  <Form.Group className="mb-3">
                     <Form.Label>Kachel-ID</Form.Label>
                     <Form.Control
                        placeholder="z.B. datenblatt"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.value);
                        }}
                        value={settings.kachelId}
                        name={"kachelId"}
                     />
                  </Form.Group>
               </Col>

               <Col>
                  <Form.Group className="mb-3">
                     <Form.Label>Position</Form.Label>
                     <Form.Control
                        // placeholder="z.B. datenblatt"
                        onChange={(e) => {
                           editSettings(e.target.name, Math.max(e.target.value, 0));
                        }}
                        type="number"
                        step={1}
                        value={settings.position ?? kachelIndex}
                        name={"position"}
                     />
                  </Form.Group>
               </Col>
               <Form.Group as={Col} className="mb-3 ">
                  <Form.Label>Übergeordnete Projektstufe</Form.Label>
                  <Form.Select
                     value={settings.stufenId}
                     name={"stufenId"}
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.value);
                     }}
                  >
                     <option value=""></option>
                     {Object.keys(projektIds).map((item) => {
                        return <option value={item}>{projektIds[item]}</option>;
                     })}
                  </Form.Select>
               </Form.Group>
            </Row>
            <Row>
               <Col>
                  <Form.Group className="mb-3">
                     <Form.Label>Standard-Eskalationsfrist (in Tagen)</Form.Label>
                     <Form.Control
                        value={settings.standardEskalationsfrist}
                        type="number"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.value);
                        }}
                        name={"standardEskalationsfrist"}
                     />
                  </Form.Group>
               </Col>
               <Col>
                  <Form.Group className="mb-3">
                     <Form.Label>Maximale-Eskalationsfrist (in Tagen)</Form.Label>
                     <Form.Control
                        value={settings.maxEskalationsfrist}
                        type="number"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.value);
                        }}
                        name={"maxEskalationsfrist"}
                     />
                  </Form.Group>
               </Col>
            </Row>

            <Row>
               <Form.Group as={Col} className="mb-3" controlId="pflichtKachel">
                  <Form.Check
                     inline
                     className="checkbox-container"
                     label="Pflichtkachel"
                     name="pflichtKachel"
                     checked={settings.pflichtKachel}
                     type="checkbox"
                     onChange={(e) => {
                        editSettings(e.target.name, e.target.checked);
                     }}
                     id={"pflichtKachel"}
                  />
               </Form.Group>
               <Col>
                  <Form.Group className="mb-3" controlId="pflichtEskalation">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="Pflicht-Eskalation"
                        name="pflichtEskalation"
                        checked={settings.pflichtEskalation}
                        type="checkbox"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.checked);
                        }}
                        id={"pflichtEskalation"}
                     />
                  </Form.Group>
               </Col>
            </Row>
            <Row>
               <Col>
                  <Form.Group className="mb-3" controlId="adminFreigabe">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="mit Admin-Freigabe"
                        name="adminFreigabe"
                        checked={settings.adminFreigabe}
                        type="checkbox"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.checked);
                        }}
                        id={"adminFreigabe"}
                     />
                  </Form.Group>
               </Col>
               <Col>
                  <Form.Group className="mb-3" controlId="pmFreigabe">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="mit Projektmanager-Freigabe"
                        name="pmFreigabe"
                        checked={settings.pmFreigabe}
                        type="checkbox"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.checked);
                        }}
                        id={"pmFreigabe"}
                     />
                  </Form.Group>
               </Col>
            </Row>
            <Row>
               <Col>
                  <Form.Group className="mb-3" controlId="optional">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="optional (standardmäßig ausgeblendet)"
                        name="optional"
                        checked={settings.optional}
                        type="checkbox"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.checked);
                        }}
                        id={"optional"}
                     />
                  </Form.Group>
               </Col>
               <Col>
                  <Form.Group className="mb-3" controlId="notRemovable">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="nicht löschbar"
                        name="notRemovable"
                        checked={settings.notRemovable}
                        type="checkbox"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.checked);
                        }}
                        id={"notRemovable"}
                     />
                  </Form.Group>
               </Col>
            </Row>
            <Row>
               <Col>
                  <Form.Group className="mb-3" controlId="unSkippable">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="nicht schnell abschließbar"
                        name="unSkippable"
                        checked={settings.unSkippable}
                        type="checkbox"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.checked);
                        }}
                        id={"unSkippable"}
                     />
                  </Form.Group>
               </Col>
               <Col>
                  <Form.Group className="mb-3" controlId="deprecated">
                     <Form.Check
                        inline
                        className="checkbox-container"
                        label="veraltet (wird ausgeblendet, wenn leer)"
                        name="deprecated"
                        checked={settings.deprecated}
                        type="checkbox"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.checked);
                        }}
                        id={"deprecated"}
                     />
                  </Form.Group>
               </Col>
            </Row>
            <Row>
               <Col>
                  <Form.Group className="mb-3" controlId="hinweis">
                     <Form.Label>
                        Hinweistext (wird oben in der Kachel angezeigt und HTML-Formatierung möglich)
                     </Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        style={{ minHeight: "115px", fieldSizing: "content" }}
                        as="textarea"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.value);
                        }}
                        name="hinweis"
                        value={settings.hinweis}
                     />
                  </Form.Group>
               </Col>
            </Row>
            <FilterGenerator editSettings={editSettings} respField={"filter"} allKacheln={allKacheln} />
            <Row>
               <Col>
                  <Form.Group className="mb-3" controlId="filter">
                     <Form.Label>Filter (JSON)</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        style={{ minHeight: "120px" /* fieldSizing: "content" */ }}
                        as="textarea"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.value);
                        }}
                        name="filter"
                        value={settings.filter}
                     />
                     {!isJSON(settings.filter) && (
                        <div className="mt-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                           invalide Syntax
                        </div>
                     )}
                  </Form.Group>
               </Col>
            </Row>
            <Row>
               <Col>
                  <Form.Group className="mb-3" controlId="permittedUsers">
                     <Form.Label>Erlaubte Nutzer (JSON)</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        style={{ minHeight: "100px", fieldSizing: "content" }}
                        as="textarea"
                        onChange={(e) => {
                           editSettings(e.target.name, e.target.value);
                        }}
                        name="permittedUsers"
                        value={settings.permittedUsers}
                     />
                  </Form.Group>
               </Col>
            </Row>
         </Form>
         {loading === "success" && <Alert variant="success">Speichern erfolgreich!</Alert>}
         {loading === "error" && <Alert variant="success">Fehler!</Alert>}
         <div>
            {!showWarning ? (
               <Button variant="warning" onClick={() => setShowWarning(true)}>
                  Stufen entfernen
               </Button>
            ) : (
               <>
                  <Button variant="secondary" onClick={() => setShowWarning(false)}>
                     Abbrechen
                  </Button>{" "}
                  <Button
                     variant="danger"
                     onClick={async () => {
                        await archiveKachel();
                     }}
                  >
                     Endgültig löschen!
                  </Button>
               </>
            )}
         </div>
         <div className="d-flex justify-content-end mt-2">
            <Button
               onClick={() => {
                  let { fields, ...basicSettings } = settings;
                  let newKacheln = structuredClone(allKacheln);
                  newKacheln[data.stufenId].kachel[kachelIndex] = {
                     ...newKacheln[data.stufenId].kachel[kachelIndex],
                     ...basicSettings,
                  };
                  setAllKacheln(newKacheln);

                  downloadObjectAsJson(newKacheln, "kacheln_" + new Date().toLocaleString());
                  /* downloadObjectAsJson(
                     {
                        ...newKacheln[data.stufenId].kachel[kachelIndex],
                        ...basicSettings,
                     },
                     settings.kachelId + new Date().toLocaleString(),
                  ); */
               }}
               className="ms-1"
            >
               Herunterladen
            </Button>
            <Button
               onClick={async () => {
                  try {
                     setLoading("loading");
                     await updateKachel();

                     let { fields, ...basicSettings } = settings;
                     let newKacheln = structuredClone(allKacheln);
                     newKacheln[data.stufenId].kachel[kachelIndex] = {
                        ...newKacheln[data.stufenId].kachel[kachelIndex],
                        ...basicSettings,
                     };
                     setAllKacheln(newKacheln);

                     localStorage.setItem("kacheln", JSON.stringify(newKacheln));

                     setLoading("success");
                     setTimeout(() => {
                        setLoading(false);
                     }, 5000);
                  } catch (error) {
                     setLoading("error");
                     window.alert(error);
                  }
               }}
               className="ms-1"
            >
               {loading === "loading" ? <SpinnerGroup /> : "Speichern und Hochladen"}
            </Button>
         </div>
      </div>
   );
}

function downloadObjectAsJson(exportObj, exportName) {
   // 1. Objekt in JSON-String umwandeln (mit Einrückung für Lesbarkeit)
   const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj, null, 2));

   // 2. Ein unsichtbares <a> Element erstellen
   const downloadAnchorNode = document.createElement("a");
   downloadAnchorNode.setAttribute("href", dataStr);
   downloadAnchorNode.setAttribute("download", exportName + ".json");

   // 3. In den Body einfügen, klicken und wieder entfernen
   document.body.appendChild(downloadAnchorNode);
   downloadAnchorNode.click();
   downloadAnchorNode.remove();
}
